import { onMounted, onUnmounted, reactive } from "vue";
import { t } from "@/plugins/vue-i18n";

import { ObjectAny } from "@/types/functions";

interface TranslationOption extends ObjectAny {
    translationProps?: ObjectAny | number;
}

export function useLanguageArray<T extends TranslationOption>(initContent: T[], translationTarget: keyof T): {
    content: T[]
} {
    const contentInfos = initContent
    const content = reactive<any[]>([])

    const update = () => {
        content.splice(0)
        for (let i = 0; i < contentInfos.length; i++) {
            let field = JSON.parse(JSON.stringify(contentInfos[i]))

            if (!translationTarget) {
                field = t(field, field.translationProps)
                content.push(field)
                continue;
            }

            if (field[translationTarget]) field[translationTarget] = t(field[translationTarget], field.translationProps)
            else field[translationTarget] = ''

            content.push(field)
        }
    }

    onMounted(() => {
        update()
        window.addEventListener('change-language', update)
    })

    onUnmounted(() => window.removeEventListener('change-language', update))

    return {
        content
    }
}

export function useLanguageArrayMulti<T = any>(initContent: T[], translationTargets: string[]): { content: T[] } {
    const contentInfos = initContent
    const content = reactive<any[]>([])

    const update = () => {
        content.splice(0)
        for (let i = 0; i < contentInfos.length; i++) {
            const field = JSON.parse(JSON.stringify(contentInfos[i]))

            for (const translationTarget of translationTargets) {
                if (field[translationTarget]) field[translationTarget] = t(field[translationTarget])
                else field[translationTarget] = ''
            }

            content.push(field)
        }
    }

    onMounted(() => {
        update()
        window.addEventListener('change-language', update)
    })

    onUnmounted(() => window.removeEventListener('change-language', update))

    return {
        content
    }
}
